import { createContext } from 'react';
import { Nullable } from '@steelbuy/ts-shared';
import { FormContextValue } from './FormContextValue';

export const FormContext = createContext<Nullable<FormContextValue>>(null);
